import React from 'react';
import '/client/app/styles/text.scss';

export default function EmailConfirmationSuccessView() {
	return <div>Thank you. Your account is now fully active.</div>;
}
